import FruitCard from "../../layouts/FruitCard";
import bg from "/cywe-assets/card/orange.png";
import fruit from "/cywe-assets/fruit/orange.png";

export default function Orange({
	setValue,
	value,
}: {
	setValue: (value: number) => void;
	value: number;
}) {
	return (
		<>
			<FruitCard
				title="God is Faithful & will do it!"
				description="We all have a purpose in life, realizing it is in relationship with God, while fulfilling His quest for this life. Simply to have faith in God because He only wants the best for all of us. We also need to have faith in people and that we can live in peace and develop trust with each other. Giving everyone a fair chance and believing that they can too become trustworthy within an appropriate situation to prove their heart. Always encouraging others by example, and showing fairness and loyalty to each other."
				bg={bg}
				fruit={fruit}
				setValue={setValue}
				value={value}
				back="/experience/"
				next="/experience/3"
			/>
		</>
	);
}
